import { useEffect } from 'react';

import { useLocales } from 'src/locales/use-locales';

export function useDocumentLang() {
  const { currentLang } = useLocales();

  useEffect(() => {
    document.documentElement.lang = currentLang.htmlLang;
  }, [currentLang.htmlLang]);
}
